import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

const styles = theme => ({
  root: {
    position: "relative",
    zIndex: 3,
    background: "#fff"
  },
  icon: {
    position: "absolute",
    top: 10,
    left: 10
  },
  textFieldRoot: {
    padding: 0,
  },
  textFieldInput: {
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: "10px 12px 10px 42px",
    borderRadius: "4px"
  },
  textFieldFormLabel: {
    fontSize: 18,
  }
});

const SearchBox = ({ classes, InputProps, InputLabelProps, ...rest }) => (
  <div className={classes.root}>
    <SearchIcon className={classes.icon}/>
    <TextField
      InputProps={{
        disableUnderline: true,
        classes: {
          root: classes.textFieldRoot,
          input: classes.textFieldInput,
        },
      }}
      InputLabelProps={{
        shrink: true,
        className: classes.textFieldFormLabel,
      }}
      {...rest}
    />
  </div>
)

export default withStyles(styles)(SearchBox);